var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 19.0234L5.153 23.1359L6.79362 14.8776L0.611328 9.16094L8.97279 8.16927L12.4999 0.523438L16.027 8.16927L24.3884 9.16094L18.2061 14.8776L19.8467 23.1359L12.4999 19.0234ZM12.4999 16.6359L16.9238 19.112L15.9353 14.1401L19.6572 10.6974L14.6228 10.1005L12.4999 5.4974L10.377 10.1016L5.34258 10.6974L9.06445 14.1401L8.07591 19.112L12.4999 16.6359V16.6359Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.7cc5e23e201d45e96c9b35468539ff9c.svg";
export { ForwardRef as ReactComponent };